var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHidemenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 64,
    width: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hidemenu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 3,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    className: "nc-icon-wrapper",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: " 22,50 32,58 42,50 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6,
    width: 60,
    height: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 16,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 16,
    x2: 28,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 16,
    x2: 40,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 16,
    x2: 52,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 28,
    x2: 16,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 28,
    x2: 40,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 28,
    x2: 52,
    y2: 28
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidemenu);
export default __webpack_public_path__ + "static/media/hidemenu.2af5e1e8c178ec905af254bb8d3b249c.svg";
export { ForwardRef as ReactComponent };